module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-17.1741c377.png";